import validate from "/var/www/projects/hillceramic.se/releases/20250425071938Z/node_modules/nuxt/dist/pages/runtime/validate.js";
export const globalMiddleware = [
  validate
]
export const namedMiddleware = {}